import request from '@/units/request';

export default {
  list: (data) =>
    request({
      url: 'cart/index',
      method: 'GET',
      params: { goods_type: 'contract' },
      custom: {
        showLoading: false,
        auth: true,
      },
    }),
  append: (data) =>
    request({
      url: 'cart/update',
      method: 'POST',
      form: true,
      custom: {
        showSuccess: true,
        successMsg: '已添加到购物车~',
      },
      data: {
        ...data,
        type: 'inc',
      },
    }),
  // 删除购物车
  delete: (ids) =>
    request({
      url: 'cart/delete',
      method: 'DELETE',
      params: {
        id: ids.toString(),
      },
    }),
  update: (data) =>
    request({
      url: 'cart/update',
      method: 'POST',
      form: true,
      data: {
        ...data,
        type: 'cover',
      },
    }),
};
